  import { Component, Input, NgZone, ElementRef } from '@angular/core';
  import {Http, Headers, Response} from '@angular/http';
  import { Observable } from "rxjs/Observable";
  import 'rxjs/add/operator/map'
  import { FormsModule } from '@angular/forms';
  import { DatePipe } from '@angular/common';
  import { httpService } from '../service/servicio'
  import { ToastsManager } from 'ng2-toastr/ng2-toastr';
  import { ViewContainerRef } from '@angular/core';
  import * as jsPDF from 'jspdf'

@Component({
  selector: 'app-clientes',
  templateUrl: './clientes.component.html',
  styleUrls: ['./clientes.component.css']
})
export class ClientesComponent {


    constructor (private http: httpService,  public toastr: ToastsManager, vcr: ViewContainerRef, private elem: ElementRef) {

        this.toastr.setRootViewContainerRef(vcr);
        this.descargarClientes();
        this.orden(3);

      };


      uploaded = {
        Status:0,
        Text:''

      }

      @Input() clientes: any = [];

      clienteSearch: string ='';
      place:string = 'Buscar por Cliente';
      sort: string = 'Nombre';


      listar() {

        // Only pt supported (not mm or in)

        let doc = new jsPDF('l', 'pt');

        doc.setFont("courier");
        doc.setFontSize(14);
        doc.setFontType("bold");

        doc.text(15,20,"Listado de Clientes ( " + this.filtro().length + " )")
        doc.text(720, 20, this.http.hoy())
        doc.line(15,25,800,25);

        let lineas:any = [];
        let y: number = 40;

        doc.setFontSize(10);
        doc.setFontType("normal");
      /*
        doc.text(0,5, '12345678901234567890123456789012345678901234567890123456789012345678901234567890123456789012345678901234567890123456789012345678901234567890');
        doc.text(0,15,'         1         2         3         4         5         6         7         8         9         10       11        12        13        14');
        for (let i=0; i < 800; i+=10) {

          doc.text(i, 25,".");
          doc.text(5,i,".");
        }
        let ii:number = 0;
        let c:number = 0;

        for (let i=0; i < 800; i+=10) {
          ii ++;
          if (ii == 10) {
            c++;
            doc.text(i, 25, c.toString());
            doc.text(10, i, c.toString());

            ii = 0 };

        }
      */
        doc.setFontSize(10);
        doc.setFontType("bold");

        doc.text(15, y, 'Id');
        doc.text(40, y, 'Documento');
        doc.text(120, y, 'Nombre');
        doc.text(400, y, 'Poblacion');
        doc.text(600, y, 'Direccion');

        doc.line(15, y + 5, 800, y + 5)

       y = 60;
       doc.setFontType("normal");
       let sw:boolean =true;

       let tabla:any = this.filtro();

        tabla.forEach(cliente => {
          if (sw) {
           doc.setTextColor(128,128,128)
         }else {
           doc.setTextColor(0,0,0)
         }

         doc.text(15, y, cliente.Id);
         doc.text(40, y, cliente.documento.slice(0,12));
         doc.text(120, y, cliente.Nombre.slice(0,45));
         doc.text(400, y, cliente.poblacion.slice(0,32));
         doc.text(600, y, cliente.direccion.slice(0,35));

         sw = !sw;

         y+=20;
         if (y > 550)  { doc.addPage(); y = 35 }

        })


            doc.save('Clientes.pdf');


      };





      orden(n) {
        if (n == 1) { this.sort='Id'; this.place='Buscar por Id' };
        if (n == 2) { this.sort='documento'; this.place='Buscar por Documento' };
        if (n == 3) { this.sort='Nombre'; this.place='Buscar por Nombre' };
        if (n == 4) { this.sort='direccion'; this.place='Buscar por Direccion' };
        if (n == 5) { this.sort='poblacion'; this.place='Buscar por Poblacion' };
        this.ordenar(this.sort);
      }

      ordenar(sort) {

        let campo1, campo2: any;

        this.clientes.sort(function(a, b){

          switch (sort) {
          case "Id":
            campo1 = a.Id;
            campo2 = b.Id;
            break;
          case "documento":
            campo1 = a.documento;
            campo2 = b.documento;
            break;
          case "Nombre":
          campo1 = a.Nombre;
          campo2 = b.Nombre;
            break;
          case "direccion":
          campo1 = a.direccion;
          campo2 = b.direccion;
            break;
          case "poblacion":
          campo1 = a.poblacion;
          campo2 = b.poblacion;
            break;

          default:
        }

          if ( campo1 < campo2 )
              return -1;
          if ( campo1 > campo2 )
              return 1;
          return 0;
        });

      }

     quitarfiltro(tipo: Number) {
        this.clienteSearch = '';
     }

    filtro() {

        return this.clientes.filter((cliente) => {
           if (this.sort == 'Nombre')
              return cliente.Nombre.toLowerCase().indexOf(this.clienteSearch.toLowerCase()) != -1;
           if (this.sort == 'Id')
             return cliente.Id.toLowerCase().indexOf(this.clienteSearch.toLowerCase()) != -1;
           if (this.sort == 'direccion')
             return cliente.direccion.toLowerCase().indexOf(this.clienteSearch.toLowerCase()) != -1;
           if (this.sort == 'documento')
             return cliente.documento.toLowerCase().indexOf(this.clienteSearch.toLowerCase()) != -1;
           if (this.sort == 'poblacion')
             return cliente.poblacion.toLowerCase().indexOf(this.clienteSearch.toLowerCase()) != -1;

         });
    }


    descargarClientes() {

            this.http.descargarClientes()
                    .subscribe(cliente => {
                         this.clientes = cliente;

                    }, err => {

                    }, () => {

                      console.log(this.clientes);

             });
          }



    pulsado(cliente) {
        this.http.clienteGrabar = cliente;
        this.http.clienteGrabar.observaciones = this.http.miReplace(this.http.clienteGrabar.observaciones, "$", "\r");

        this.http.sw.mostrarClientes = false;
        this.http.sw.mostrarMenu = false;
        this.http.sw.mostrarDatosclientes = true;
    }

    crearCliente() {

       this.http.clienteGrabar = this.http.nuevoCliente();
       this.http.sw.mostrarDatosclientes = true;
    }



}



// WEBPACK FOOTER //
// /Users/usuario/Desktop/duran/duran-web/src/app/clientes/clientes.component.ts